export enum ERROR_CODE
{ NONE                = 200
, SOMETHING_WAS_WRONG = 400
, TOKEN_EXPIRED       = 401
, UNAUTHORIZED        = 401
, FORBIDDEN           = 403
, INTERNAL            = 500
} ;

export enum TEXT
{ UI_BUTTON_CREATE
, UI_BUTTON_NEW
, UI_BUTTON_OK
, UI_BUTTON_CANCEL
, UI_BUTTON_SAVE
, UI_BUTTON_LOGIN
, UI_BUTTON_SEND

, UI_MENU_USERS
, UI_MENU_WORKGROUPS
, UI_MENU_CLIENTS
, UI_MENU_JOBS
, UI_MENU_KEY_MASTERING

, UI_NAME
, UI_DATE
, UI_ADDR
, UI_DESC
, UI_PRICE
, UI_LOGIN_USERNAME
, UI_LOGIN_CLOUDNAME
, UI_LOGIN_PASSWORD
, UI_NO_DATA
, UI_EMAIL
, UI_ROLE
, UI_USERNAME
, UI_MACHINES
, UI_USERS
, UI_DATE_FORMAT
, UI_SING_OUT
, UI_MKS_TYPE
, UI_KEY_APP
, UI_CLIENT
, UI_FILE
, UI_SELECT_FILE

, WORKGROUPS_NEW_TITLE
, WORKGROUPS_EDIT_TITLE
, WORKGROUPS_NAME

, USERS_NEW_TITLE
, USERS_EDIT_TITLE

, MACHINES_NEW
, MACHINE_TYPE
, MACHINE_NUM_JOBS
, MACHINE_SERIAL_NO
, MACHINE_NAME

, JOB_EDIT_TITLE
, JOB_NEW_TITLE
, JOB_KEY_TYPE
, JOB_NUM_KEYS
, JOB_MACHINE
, JOB_STATUS
, JOB_DATE
, JOB_QUANTITY
, JOB_FILTER_BY_STATUS
, JOB_FILTER_BY_CLIENT
, JOB_FILTER_BY_MACHINE_NAME
, JOB_FILTER_BY_KEY_TYPE
, JOB_FILTER_BY_DATE

, KEY_MASTERING_LAUNCH
, KEY_MASTERING_LAUNCH_N
, KEY_MASTERING_NEW_TITLE
, KEY_MASTERING_WILL_CREATE_N_KEYS
, KEY_MASTERING_KEYS_CREATED
, KEY_MASTERING_NAME

, CLIENT_NEW_TITLE
, CLIENT_EDIT_TITLE
, CLIENT_SURNAMES
, CLIENT_BIRTHDAY
, CLIENT_NOTES
, CLIENT_ADDRESS
, CLIENT_CONTACT
, CLIENT_CONTACT_EMAIL
, CLIENT_CONTACT_PHONE
, CLIENT_CONTACT_FAX
, CLIENTS_FILTER_BY_NAME
, CLIENTS_FILTER_BY_ADDR
, CLIENTS_FILTER_BY_CONTACT
, CLIENT_ADDR_STREET1
, CLIENT_ADDR_STREET2
, CLIENT_ADDR_CITY
, CLIENT_ADDR_PROVINCE
, CLIENT_ADDR_ZIP_CODE
, CLIENT_ADDR_COUNTRY

, LOGIN_FORGOT_PASSWORD_QUESTION
, LOGIN_FORGOT_PASSWORD_TITLE
, LOGIN_SLOGAN
, LOGIN_QUALITY_POINTS

, ARE_YOU_SURE

, ERROR_NONE
, ERROR_LOGIN_FORBIDDEN
, ERROR_LOGIN_UNAUTHORIZED
, ERROR_INTERNAL
, ERROR_FORBIDDEN
, ERROR_UNKNOWN

, PAGE_NOT_FOUND

, LEGAL_TOS_LINK
, LEGAL_TOS_TEXT
, LEGAL_PRIVACY_LINK
, LEGAL_PRIVACY_TEXT
, LEGAL_MODEL_LINK
, LEGAL_MODEL_TEXT

, KEY_MODEL
, KEY_SERIES
, KEY_CODE
, KEY_DATA_SHEET
, KEY_BITING
, KEY_APPLICATION

, ENUM_JOB_STATE_PENDING
, ENUM_JOB_STATE_CANCELLED
, ENUM_JOB_STATE_COMPLETE
, ENUM_JOB_STATE_PROCESSING

, ENUM_USER_ROLE_ADMIN
, ENUM_USER_ROLE_MANAGER
, ENUM_USER_ROLE_USER

, ENUM_KEY_APP_CAR
, ENUM_KEY_APP_HOME
, ENUM_KEY_APP_SECURITY
, ENUM_KEY_APP_LOCK
, ENUM_KEY_APP_UNSPECIFIED

, FORM_HAS_ERRORS
}

export interface IErrorToText
{
  [ code: number ]: TEXT
}

export const ERROR_MSG =
{
  LOGIN:
  { [ERROR_CODE.NONE     ]: TEXT.ERROR_NONE
  , [ERROR_CODE.UNAUTHORIZED ]: TEXT.ERROR_LOGIN_UNAUTHORIZED
  , [ERROR_CODE.FORBIDDEN]: TEXT.ERROR_LOGIN_FORBIDDEN
  , [ERROR_CODE.INTERNAL ]: TEXT.ERROR_INTERNAL
  , [ERROR_CODE.SOMETHING_WAS_WRONG ]: TEXT.ERROR_UNKNOWN
  }

, GENERAL:
  { [ERROR_CODE.NONE     ]: TEXT.ERROR_NONE
  , [ERROR_CODE.FORBIDDEN]: TEXT.ERROR_FORBIDDEN
  , [ERROR_CODE.INTERNAL ]: TEXT.ERROR_INTERNAL
  , [ERROR_CODE.SOMETHING_WAS_WRONG ]: TEXT.ERROR_UNKNOWN
  }

}